/**
 * Infinite FB/TikTok Pixels (embede.js) assigns to a bare global `banner`.
 * Shoppy Mobile App Banner exposes a lexical/global `const banner` (HTMLElement),
 * so Infinite's gdprCompliece throws "Assignment to constant variable" on a timer.
 * Replace gdprCompliece with an equivalent that uses a local variable.
 */
(function () {
  if (window.__geekoInfinitePixelPatch) return;
  window.__geekoInfinitePixelPatch = true;

  function patchedGdprCompliece(dbData) {
    try {
      if (
        !window.Shopify ||
        !window.Shopify.customerPrivacy ||
        typeof window.Shopify.customerPrivacy.shouldShowBanner !== 'function' ||
        typeof window.Shopify.customerPrivacy.currentVisitorConsent !== 'function'
      ) {
        return;
      }

      var privacyBanner = window.Shopify.customerPrivacy.shouldShowBanner();
      // Original script uses global `var checkAnalytic`; write via window for strict-safe patching.
      var consent = window.Shopify.customerPrivacy.currentVisitorConsent();
      window.checkAnalytic = consent;

      if (typeof DbPixels === 'undefined' || DbPixels == null || !dbData || !dbData[2]) {
        return;
      }

      var gdprdb = dbData[2].GDPRComplice;
      if (gdprdb != 'no') return;

      var analytics = consent && consent.analytics;
      var shouldForce =
        analytics == 'no' ||
        (privacyBanner == true && analytics != 'yes' && analytics != '') ||
        (privacyBanner == false && analytics == '');

      if (!shouldForce) return;

      var callback = function () {};
      window.Shopify.customerPrivacy.setTrackingConsent(true, callback);
      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          analytics: true,
          marketing: true,
          preferences: true,
          sale_of_data: true,
        },
        callback
      );
      window.Shopify.customerPrivacy.setTrackingConsent(true);
    } catch (err) {
      if (typeof console !== 'undefined' && console.warn) {
        console.warn('[geeko-infinite-pixel-patch] gdprCompliece failed', err);
      }
    }
  }

  function applyPatch() {
    if (typeof window.gdprCompliece !== 'function') return false;
    if (window.gdprCompliece.__geekoPatched) return true;
    window.gdprCompliece = patchedGdprCompliece;
    window.gdprCompliece.__geekoPatched = true;
    return true;
  }

  if (applyPatch()) return;

  var tries = 0;
  var timer = setInterval(function () {
    tries += 1;
    if (applyPatch() || tries > 80) {
      clearInterval(timer);
    }
  }, 250);
})();
